// /src/js/blocks/counter.js
import {
	animateCountersIn,
	observeInView,
	getScrollRotator,
} from "@/js/animator";
import "./counter.scss";

(function initCounterBlock() {
	const SELECTOR = ".counter";
	const COG_SELECTOR = ".counter-cog";

	function boot(root = document) {
		// Animate counters when their section enters view (once)
		observeInView(root, {
			selector: SELECTOR,
			threshold: 0.3,
			onEnter: (section) =>
				animateCountersIn(section, { selector: ".counter-value" }),
			once: true,
		});

		// Register rotating cogs (shared rotator across the whole site)
		const rotator = getScrollRotator();
		root.querySelectorAll(SELECTOR).forEach((section) => {
			const cog = section.querySelector(COG_SELECTOR);
			if (cog) {
				// Optional per-element speed via data-rotate-speed
				const speedAttr = parseFloat(
					cog.getAttribute("data-rotate-speed")
				);
				const speed = Number.isFinite(speedAttr) ? speedAttr : 0.5;
				rotator.register(cog, { speed });
			}
		});
	}

	// Front-end
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => boot());
	} else {
		boot();
	}

	// Gutenberg editor hot-insert
	if (window.wp && wp.data && wp.data.subscribe) {
		let last = 0;
		wp.data.subscribe(() => {
			const count = document.querySelectorAll(SELECTOR).length;
			if (count !== last) {
				last = count;
				boot(document);
			}
		});
	}
})();
